<template>
  <div>
    <vue-data-table
      :headers="headers"
      :data="purchases"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
      :show-filter="true"
      :filter-fields="filterFields"
      :filter-data="filter"
      :filter-title="'Filtrer les achats'"
      :table-actions="tableActions"
      @filter="onFilter"
      @reset="onReset"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
      filter: {
        supplier_reference: "",
        item_reference: "",
        startDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        paymentStatus: "",
      },
      filterFields: [
        {
          type: "select",
          model: "supplier_reference",
          label: "Fournisseur",
          options: [],
          labelColumn: "society",
          valueColumn: "reference",
          placeholder: "Sélectionner un fournisseur",
        },
        {
          type: "select",
          model: "item_reference",
          label: "Produit",
          options: [],
          labelColumn: "fullName",
          valueColumn: "reference",
          placeholder: "Sélectionner un produit",
        },
        {
          type: "dropdown",
          model: "paymentStatus",
          label: "État de paiement",
          options: [
            { value: "", label: "--" },
            { value: "Payé", label: "Payé" },
            { value: "Impayé", label: "Impayé" },
          ],
        },
      ],
      headers: [
        { field: "reference", label: "Référence", class: "" },
        { field: "supplierSociety", label: "Fournisseur", class: "" },
        { field: "date", label: "Date", class: "" },
        { field: "totalPriceTTC", label: "M. Total", class: "text-primary " },
        {
          field: "totalQuantity",
          label: "Total Qté",
          class: "text-secondary ",
        },
        { field: "amountPaid", label: "M. Payé", class: "text-success " },
        { field: "amountUnpaid", label: "M. Impayé", class: "text-danger " },
        { field: "userFullName", label: "Créer par", class: "" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-info-square",
          class: "btn",
          action: (purchase) => {
            this.$router.push({
              name: "purchases-details",
              params: { reference: purchase.reference },
            });
          },
        },
      ],
      summableColumns: [
        { field: "totalPriceTTC", class: "text-primary" },
        { field: "totalQuantity", class: "text-secondary" },
        { field: "amountPaid", class: "text-success" },
        { field: "amountUnpaid", class: "text-danger" },
      ],
      tableActions: [
        {
          title: "Actualiser",
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => {
            this.refresh();
          },
        },
        {
          title: "Créer de nouveaux achats",
          icon: "bi bi-plus-square",
          class: "btn btn-primary",
          action: () => {
            this.$router.push({ name: "purchases-create" });
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("purchase", {
      purchases: "getAll",
      totalQuantity: "getPurchasesTotalQuantity",
      totalPriceTTC: "getPurchasesTotalPriceTTC",
      totalPaid: "getPurchasesTotalPaid",
      totalUnpaid: "getPurchasesTotalUnpaid",
    }),
    ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("section", {
      sections: "getAll",
    }),
    ...mapGetters("auth", {
      userRole: "getUserRole",
    }),
  },
  mounted() {
    this.$store.dispatch("purchase/getAll");
    this.$store.dispatch("supplier/getAll");
    this.$store.dispatch("item/getAll");
  },
  watch: {
    // Update filterFields options when suppliers are loaded
    suppliers: {
      handler(newSuppliers) {
        if (newSuppliers && newSuppliers.length > 0) {
          const supplierField = this.filterFields.find(
            (f) => f.model === "supplier_reference"
          );
          if (supplierField) {
            supplierField.options = newSuppliers;
          }
        }
      },
      immediate: true,
    },
    // Update filterFields options when items are loaded
    items: {
      handler(newItems) {
        if (newItems && newItems.length > 0) {
          const itemField = this.filterFields.find(
            (f) => f.model === "item_reference"
          );
          if (itemField) {
            itemField.options = newItems;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    async search(value) {
      return await this.$store.commit("purchase/search", value);
    },
    async refresh() {
      return await this.$store.dispatch("purchase/getAll");
    },

    async toFilter(data) {
      return await this.$store.dispatch("purchase/filter", data);
    },
    onFilter(filterData) {
      // Update local filter
      this.filter = { ...filterData };
      // Apply filter via store
      this.toFilter(filterData);
    },
    onReset(resetData) {
      // Reset local filter
      this.filter = {
        supplier_reference: "",
        item_reference: "",
        startDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        paymentStatus: "",
      };
      // Reset filter in store
      this.toFilter(this.filter);
    },
  },
  filters: {
    toFixedWithSpace: (value) => {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
    date: (value) => {
      return moment(value).format("DD-MM-YYYY");
    },
  },
};
</script>
